module.exports = __webpack_public_path__ + "static/media/selenium.db9de5c6.svg";